import type { TFunction } from 'i18next';

// Plus/アップグレード関連の文言を一元管理するユーティリティ。
// t を受け取って各コンポーネントで使うことで、文言の変更漏れを防ぐ。
export const getUpgradeCopy = (
  t: TFunction,
  trialPeriodDays?: number | null
) => {
  const ctaTrial =
    trialPeriodDays && trialPeriodDays > 0
      ? t('{{days}}日間無料で試す', { days: trialPeriodDays })
      : t('無料で試す');

  return {
    headline: t('さらなる可能性を解放しましょう。'),
    sub: t('RuleWatcher Plus の機能でリサーチをさらに強化できます。'),
    ctaTrial,
    ctaUpgrade: t('Plusプランにアップグレード'),
    dismiss: t('閉じる'),
    basicCta: t('Basic(無料)プランではじめる'),
    trialLimitNote: t('トライアル期間中はダウンロード上限100件です。'),
  };
};
